module.exports = __webpack_public_path__ + "static/media/m_w_hr_35.e6040bc2.png";